"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addSendFrequencyTracking = void 0;

var _PortalSettingsKeys = _interopRequireDefault(require("settings-ui-sdk/constants/PortalSettingsKeys"));

var _UsageTracker = _interopRequireDefault(require("settings-ui-app/utils/UsageTracker"));

var _utils = require("settings-ui-sdk/EmailFrequency/utils");

var addSendFrequencyTracking = function addSendFrequencyTracking(key, value) {
  switch (key) {
    case _PortalSettingsKeys.default.EMAIL_FREQUENCY_ENABLED:
      return _UsageTracker.default.track('sendFrequencyActivation', {
        status: value == 'true'
      });

    case _PortalSettingsKeys.default.EMAIL_FREQUENCY_LIMIT:
      return _UsageTracker.default.track('sendFrequencyInteraction', {
        limit: Number(value)
      });

    case _PortalSettingsKeys.default.EMAIL_FREQUENCY_DAYS:
      return _UsageTracker.default.track('sendFrequencyInteraction', {
        period: (0, _utils.daysNumberToTag)(value)
      });

    default:
      return null;
  }
};

exports.addSendFrequencyTracking = addSendFrequencyTracking;